import {
  SALARY_UPLOAD_REQUEST,
  SALARY_UPLOAD_SUCCESS,
  SALARY_UPLOAD_FAIL,
  SALARY_UPLOAD_RESET,
  SALARY_CREATE_REQUEST,
  SALARY_CREATE_SUCCESS,
  SALARY_CREATE_FAIL,
  SALARY_CREATE_RESET,
  SALARY_LIST_REQUEST,
  SALARY_LIST_SUCCESS,
  SALARY_LIST_FAIL,
  SALARY_LIST_RESET,
  SALARY_DETAILS_REQUEST,
  SALARY_DETAILS_SUCCESS,
  SALARY_DETAILS_FAIL,
  SALARY_DETAILS_RESET,
  SALARY_UPDATE_REQUEST,
  SALARY_UPDATE_SUCCESS,
  SALARY_UPDATE_FAIL,
  SALARY_UPDATE_RESET,
  SALARY_DELETE_REQUEST,
  SALARY_DELETE_SUCCESS,
  SALARY_DELETE_FAIL,
  SALARY_DELETE_RESET,
  SALARY_BULK_DELETE_REQUEST,
  SALARY_BULK_DELETE_SUCCESS,
  SALARY_BULK_DELETE_FAIL,
  SALARY_BULK_DELETE_RESET,
  SALARY_STATS_REQUEST,
  SALARY_STATS_SUCCESS,
  SALARY_STATS_FAIL,
  SALARY_STATS_RESET,
  SALARY_APPROVE_REQUEST,
  SALARY_APPROVE_SUCCESS,
  SALARY_APPROVE_FAIL,
  SALARY_APPROVE_RESET,
  SALARY_APPROVE_ALL_REQUEST,
  SALARY_APPROVE_ALL_SUCCESS,
  SALARY_APPROVE_ALL_FAIL,
  SALARY_APPROVE_ALL_RESET,
  SALARY_HOLD_REQUEST,
  SALARY_HOLD_SUCCESS,
  SALARY_HOLD_FAIL,
  SALARY_HOLD_RESET,
  SALARY_GENERATE_REQUEST,
  SALARY_GENERATE_SUCCESS,
  SALARY_GENERATE_FAIL,
  SALARY_GENERATE_RESET,
} from '../constants/salaryConstants';

// Upload Salary Reducer
export const salaryUploadReducer = (state = {}, action) => {
  switch (action.type) {
    case SALARY_UPLOAD_REQUEST:
      return { loading: true };
    case SALARY_UPLOAD_SUCCESS:
      return { loading: false, success: true, uploadResult: action.payload };
    case SALARY_UPLOAD_FAIL:
      return { loading: false, error: action.payload };
    case SALARY_UPLOAD_RESET:
      return {};
    default:
      return state;
  }
};

// Create Salary Reducer
export const salaryCreateReducer = (state = {}, action) => {
  switch (action.type) {
    case SALARY_CREATE_REQUEST:
      return { loading: true };
    case SALARY_CREATE_SUCCESS:
      return { loading: false, success: true, salary: action.payload };
    case SALARY_CREATE_FAIL:
      return { loading: false, error: action.payload };
    case SALARY_CREATE_RESET:
      return {};
    default:
      return state;
  }
};

// List Salary Reducer
export const salaryListReducer = (state = { records: [] }, action) => {
  switch (action.type) {
    case SALARY_LIST_REQUEST:
      return { loading: true, records: [] };
    case SALARY_LIST_SUCCESS:
      return {
        loading: false,
        records: action.payload.records,
        currentPage: action.payload.currentPage,
        totalPages: action.payload.totalPages,
        totalRecords: action.payload.totalRecords,
      };
    case SALARY_LIST_FAIL:
      return { loading: false, error: action.payload };
    case SALARY_LIST_RESET:
      return { records: [] };
    default:
      return state;
  }
};

// Salary Details Reducer
export const salaryDetailsReducer = (state = { salary: {} }, action) => {
  switch (action.type) {
    case SALARY_DETAILS_REQUEST:
      return { loading: true, ...state };
    case SALARY_DETAILS_SUCCESS:
      return { loading: false, salary: action.payload };
    case SALARY_DETAILS_FAIL:
      return { loading: false, error: action.payload };
    case SALARY_DETAILS_RESET:
      return { salary: {} };
    default:
      return state;
  }
};

// Update Salary Reducer
export const salaryUpdateReducer = (state = {}, action) => {
  switch (action.type) {
    case SALARY_UPDATE_REQUEST:
      return { loading: true };
    case SALARY_UPDATE_SUCCESS:
      return { loading: false, success: true, salary: action.payload };
    case SALARY_UPDATE_FAIL:
      return { loading: false, error: action.payload };
    case SALARY_UPDATE_RESET:
      return {};
    default:
      return state;
  }
};

// Delete Salary Reducer
export const salaryDeleteReducer = (state = {}, action) => {
  switch (action.type) {
    case SALARY_DELETE_REQUEST:
      return { loading: true };
    case SALARY_DELETE_SUCCESS:
      return { loading: false, success: true };
    case SALARY_DELETE_FAIL:
      return { loading: false, error: action.payload };
    case SALARY_DELETE_RESET:
      return {};
    default:
      return state;
  }
};

// Bulk Delete Salary Reducer
export const salaryBulkDeleteReducer = (state = {}, action) => {
  switch (action.type) {
    case SALARY_BULK_DELETE_REQUEST:
      return { loading: true };
    case SALARY_BULK_DELETE_SUCCESS:
      return { loading: false, success: true, result: action.payload };
    case SALARY_BULK_DELETE_FAIL:
      return { loading: false, error: action.payload };
    case SALARY_BULK_DELETE_RESET:
      return {};
    default:
      return state;
  }
};

// Salary Stats Reducer
export const salaryStatsReducer = (state = { stats: {} }, action) => {
  switch (action.type) {
    case SALARY_STATS_REQUEST:
      return { loading: true, stats: {} };
    case SALARY_STATS_SUCCESS:
      return { loading: false, stats: action.payload };
    case SALARY_STATS_FAIL:
      return { loading: false, error: action.payload };
    case SALARY_STATS_RESET:
      return { stats: {} };
    default:
      return state;
  }
};

// Salary Approve Reducer
export const salaryApproveReducer = (state = {}, action) => {
  switch (action.type) {
    case SALARY_APPROVE_REQUEST:
      return { loading: true };
    case SALARY_APPROVE_SUCCESS:
      return { loading: false, success: true, salary: action.payload };
    case SALARY_APPROVE_FAIL:
      return { loading: false, error: action.payload };
    case SALARY_APPROVE_RESET:
      return {};
    default:
      return state;
  }
};

// Salary Approve All Reducer
export const salaryApproveAllReducer = (state = {}, action) => {
  switch (action.type) {
    case SALARY_APPROVE_ALL_REQUEST:
      return { loading: true };
    case SALARY_APPROVE_ALL_SUCCESS:
      return { loading: false, success: true, result: action.payload };
    case SALARY_APPROVE_ALL_FAIL:
      return { loading: false, error: action.payload };
    case SALARY_APPROVE_ALL_RESET:
      return {};
    default:
      return state;
  }
};

// Hold Salary Reducer
export const salaryHoldReducer = (state = {}, action) => {
  switch (action.type) {
    case SALARY_HOLD_REQUEST:
      return { loading: true };
    case SALARY_HOLD_SUCCESS:
      return { loading: false, success: true, salary: action.payload };
    case SALARY_HOLD_FAIL:
      return { loading: false, error: action.payload };
    case SALARY_HOLD_RESET:
      return {};
    default:
      return state;
  }
};

export const salaryGenerateReducer = (state = {}, action) => {
  switch (action.type) {
    case SALARY_GENERATE_REQUEST:
      return { loading: true };
    case SALARY_GENERATE_SUCCESS:
      return { loading: false, success: true, result: action.payload };
    case SALARY_GENERATE_FAIL:
      return { loading: false, error: action.payload };
    case SALARY_GENERATE_RESET:
      return {};
    default:
      return state;
  }
};
